 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-04f81313":"1e7bcaba","chunk-060adba3":"40d565a8","chunk-07115cf4":"bd3f7cd4","chunk-095d155c":"0bff7874","chunk-09ddb92d":"231a48a0","chunk-0b872cb3":"b35d565e","chunk-0be91b19":"0d61768b","chunk-0c43f131":"38ee7266","chunk-0c7a42b1":"ffdcb546","chunk-0d3a8388":"2969b4cb","chunk-0d6e340c":"4c9e8ea0","chunk-0e57e1ee":"7310041c","chunk-101c10e7":"4a31ddcf","chunk-11e12012":"84782b5b","chunk-1246da46":"21f81ab0","chunk-1574ea6a":"3f1bd3da","chunk-16ac88d4":"3e15d0d7","chunk-17a6e3d2":"9a0dd22e","chunk-17dc35f9":"4e301233","chunk-17df5e0b":"27da7d8d","chunk-187f8d3f":"eb28e333","chunk-1a7f8da6":"887e6860","chunk-1b4f0878":"a046479c","chunk-1ed9c32c":"5b50bdab","chunk-22e45ddc":"9cbbcbdf","chunk-2491c9e6":"92d6ce6b","chunk-2871195d":"abd423e8","chunk-2998ed12":"b86116d7","chunk-2b22a6bf":"eff08609","chunk-2bf9a4ce":"845b9c5c","chunk-2d0b1c43":"7ff76f87","chunk-2d0c0619":"ec0215ea","chunk-2d0c4243":"13277e59","chunk-2d0f00fc":"de791ed9","chunk-2d97faac":"18cabc4c","chunk-2e10ef62":"11e52c98","chunk-2ef06948":"169f867b","chunk-2f600c0e":"490a6637","chunk-30af345e":"91484675","chunk-3285ba3a":"1c697224","chunk-3420ed80":"74d82af4","chunk-348ddc08":"94d29572","chunk-34f5384c":"ac71eef8","chunk-35b14a4b":"03cb5c42","chunk-384befc7":"55a63b97","chunk-38bcd984":"53fd98e4","chunk-39937264":"63d9cdf7","chunk-3c766a88":"7744ddfa","chunk-3e575816":"88d2f635","chunk-3edd8698":"4c7587fe","chunk-3f3d6b59":"2e4c1239","chunk-40bf1678":"3a24c095","chunk-4399a951":"b5297ab7","chunk-43a54daa":"86198d3e","chunk-4410482c":"b5ce6e36","chunk-442ef248":"85ebb734","chunk-44463067":"c00949a9","chunk-46859440":"475754f6","chunk-46935e22":"fa67fe01","chunk-4959ce7b":"a2ba410e","chunk-4c4d891b":"ec740fd8","chunk-4d256fd4":"89207835","chunk-4eefe562":"0f76a343","chunk-504cf5c1":"cf933ad7","chunk-513adf48":"ad801089","chunk-557cc83c":"d2dcaa71","chunk-56ee7dc8":"ee2baf05","chunk-582c3a99":"ea0917c8","chunk-58f38132":"f19966a2","chunk-59e1a30f":"0aa96984","chunk-5afdcf28":"93d5363e","chunk-5c1bdabc":"3a58eedf","chunk-5c92b2f1":"899bc3e0","chunk-5d3d7a3d":"88f33017","chunk-5d4f5752":"33f06bb9","chunk-5fd65b14":"2ad41897","chunk-6193f896":"3d8a7681","chunk-62291d98":"a87da320","chunk-64b21ab9":"18fa87d4","chunk-64bc35ac":"c1523c3c","chunk-66dd2376":"14ce1a1c","chunk-6701c36e":"568f9b78","chunk-6a220b08":"a37e96e5","chunk-6dd17c6a":"b2787b5e","chunk-6e035a16":"45c2276b","chunk-6ea7681e":"3c147714","chunk-6f97a383":"9c0c372d","chunk-7044e334":"51303a8b","chunk-712d078a":"3ac1d262","chunk-718392ba":"f2f8656d","chunk-743f1192":"dd05dc81","chunk-748d5f1a":"231e57b9","chunk-7495d086":"99cf006a","chunk-74a14eea":"577d6ae0","chunk-74b16ab6":"e13724f3","chunk-758f4986":"d113a89d","chunk-78532434":"e9483a6a","chunk-79ed193c":"480b994c","chunk-7aa62b57":"14784d04","chunk-7e2b3b0e":"245f3d7c","chunk-8be36974":"e56e39fe","chunk-8c410afa":"2d578966","chunk-8d4623a0":"f25234ba","chunk-9630d94e":"046ecc84","chunk-977082c8":"5bf5421a","chunk-97bbfa4c":"c31d4ce6","chunk-97f32d3c":"8a39531b","chunk-9c2f9a36":"bc66c56b","chunk-a3a5e880":"03ba0c29","chunk-a4921472":"40a02ea4","chunk-a8f91d06":"18cf7da3","chunk-aea6b32e":"10c8ff07","chunk-b0c0a824":"cd597ad6","chunk-bf02d574":"04a530f0","chunk-c048fa8c":"f12e888c","chunk-c0d239f0":"f74c87f4","chunk-c3610276":"a45e8fad","chunk-c57376ea":"19ed8dde","chunk-c89987a2":"b30bebb3","chunk-caf4fc46":"48019cf3","chunk-cee1ab34":"dc0d06a1","chunk-d2af32e6":"99ad85dd","chunk-d6440b68":"86fcaa00","chunk-deabb03c":"4fc34842","chunk-e1d5c402":"cc5e143d","chunk-e39721ca":"7409bdcd","chunk-e5277dde":"785388e1","chunk-e5774c80":"172ad1aa","chunk-f0406aa4":"5181dc4b","chunk-f0f2fd82":"d01290a7","chunk-f27d9d74":"8690480a","chunk-f57c4bf4":"378f55a1","chunk-f6eca0ae":"44264ee5","chunk-fc1753dc":"6dd3924e","chunk-fccf9804":"7a5423b7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-04f81313":1,"chunk-060adba3":1,"chunk-07115cf4":1,"chunk-095d155c":1,"chunk-09ddb92d":1,"chunk-0b872cb3":1,"chunk-0be91b19":1,"chunk-0c43f131":1,"chunk-0c7a42b1":1,"chunk-0d3a8388":1,"chunk-0d6e340c":1,"chunk-0e57e1ee":1,"chunk-101c10e7":1,"chunk-11e12012":1,"chunk-1246da46":1,"chunk-1574ea6a":1,"chunk-16ac88d4":1,"chunk-17a6e3d2":1,"chunk-17dc35f9":1,"chunk-17df5e0b":1,"chunk-187f8d3f":1,"chunk-1a7f8da6":1,"chunk-1b4f0878":1,"chunk-1ed9c32c":1,"chunk-22e45ddc":1,"chunk-2491c9e6":1,"chunk-2871195d":1,"chunk-2998ed12":1,"chunk-2b22a6bf":1,"chunk-2bf9a4ce":1,"chunk-2d97faac":1,"chunk-2e10ef62":1,"chunk-2ef06948":1,"chunk-2f600c0e":1,"chunk-30af345e":1,"chunk-3285ba3a":1,"chunk-3420ed80":1,"chunk-348ddc08":1,"chunk-34f5384c":1,"chunk-35b14a4b":1,"chunk-384befc7":1,"chunk-38bcd984":1,"chunk-39937264":1,"chunk-3c766a88":1,"chunk-3e575816":1,"chunk-3edd8698":1,"chunk-3f3d6b59":1,"chunk-40bf1678":1,"chunk-4399a951":1,"chunk-43a54daa":1,"chunk-4410482c":1,"chunk-442ef248":1,"chunk-44463067":1,"chunk-46859440":1,"chunk-46935e22":1,"chunk-4959ce7b":1,"chunk-4c4d891b":1,"chunk-4d256fd4":1,"chunk-4eefe562":1,"chunk-504cf5c1":1,"chunk-513adf48":1,"chunk-557cc83c":1,"chunk-56ee7dc8":1,"chunk-582c3a99":1,"chunk-58f38132":1,"chunk-59e1a30f":1,"chunk-5afdcf28":1,"chunk-5c1bdabc":1,"chunk-5c92b2f1":1,"chunk-5d3d7a3d":1,"chunk-5d4f5752":1,"chunk-5fd65b14":1,"chunk-6193f896":1,"chunk-62291d98":1,"chunk-64b21ab9":1,"chunk-64bc35ac":1,"chunk-66dd2376":1,"chunk-6701c36e":1,"chunk-6a220b08":1,"chunk-6dd17c6a":1,"chunk-6e035a16":1,"chunk-6ea7681e":1,"chunk-6f97a383":1,"chunk-7044e334":1,"chunk-712d078a":1,"chunk-718392ba":1,"chunk-743f1192":1,"chunk-748d5f1a":1,"chunk-7495d086":1,"chunk-74a14eea":1,"chunk-74b16ab6":1,"chunk-758f4986":1,"chunk-78532434":1,"chunk-79ed193c":1,"chunk-7aa62b57":1,"chunk-7e2b3b0e":1,"chunk-8be36974":1,"chunk-8c410afa":1,"chunk-8d4623a0":1,"chunk-9630d94e":1,"chunk-977082c8":1,"chunk-97bbfa4c":1,"chunk-97f32d3c":1,"chunk-9c2f9a36":1,"chunk-a3a5e880":1,"chunk-a4921472":1,"chunk-a8f91d06":1,"chunk-aea6b32e":1,"chunk-b0c0a824":1,"chunk-bf02d574":1,"chunk-c048fa8c":1,"chunk-c0d239f0":1,"chunk-c3610276":1,"chunk-c57376ea":1,"chunk-c89987a2":1,"chunk-caf4fc46":1,"chunk-cee1ab34":1,"chunk-d2af32e6":1,"chunk-d6440b68":1,"chunk-deabb03c":1,"chunk-e1d5c402":1,"chunk-e39721ca":1,"chunk-e5277dde":1,"chunk-e5774c80":1,"chunk-f0406aa4":1,"chunk-f0f2fd82":1,"chunk-f27d9d74":1,"chunk-f57c4bf4":1,"chunk-f6eca0ae":1,"chunk-fc1753dc":1,"chunk-fccf9804":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-04f81313":"a673f358","chunk-060adba3":"0b69596b","chunk-07115cf4":"85e1c50c","chunk-095d155c":"067f36ca","chunk-09ddb92d":"4d9260a0","chunk-0b872cb3":"99709c1b","chunk-0be91b19":"b4553e63","chunk-0c43f131":"8bd9e271","chunk-0c7a42b1":"c5056a36","chunk-0d3a8388":"5136078b","chunk-0d6e340c":"f0279873","chunk-0e57e1ee":"4d04cf6f","chunk-101c10e7":"7af83321","chunk-11e12012":"549d16e9","chunk-1246da46":"e0ee8ee4","chunk-1574ea6a":"29d9f8ec","chunk-16ac88d4":"d6806432","chunk-17a6e3d2":"e45d9bc4","chunk-17dc35f9":"83ca327f","chunk-17df5e0b":"40bf011f","chunk-187f8d3f":"b534e757","chunk-1a7f8da6":"c71e4596","chunk-1b4f0878":"a5848edc","chunk-1ed9c32c":"af39cfd7","chunk-22e45ddc":"c0085c6c","chunk-2491c9e6":"fde72b42","chunk-2871195d":"05ad01cb","chunk-2998ed12":"00481b5e","chunk-2b22a6bf":"36565526","chunk-2bf9a4ce":"2e090545","chunk-2d0b1c43":"31d6cfe0","chunk-2d0c0619":"31d6cfe0","chunk-2d0c4243":"31d6cfe0","chunk-2d0f00fc":"31d6cfe0","chunk-2d97faac":"472e8e40","chunk-2e10ef62":"1434cbc7","chunk-2ef06948":"301ea5bf","chunk-2f600c0e":"ddd1e70c","chunk-30af345e":"c3b826c0","chunk-3285ba3a":"ea01f59a","chunk-3420ed80":"626c892a","chunk-348ddc08":"d362a4be","chunk-34f5384c":"cfcd5553","chunk-35b14a4b":"3611a346","chunk-384befc7":"28a44151","chunk-38bcd984":"817e3ebb","chunk-39937264":"1150e59b","chunk-3c766a88":"12f2d44c","chunk-3e575816":"7fb2e3ca","chunk-3edd8698":"c01ac8f0","chunk-3f3d6b59":"631d21de","chunk-40bf1678":"c9237165","chunk-4399a951":"00f2ead2","chunk-43a54daa":"ccabc611","chunk-4410482c":"71152d38","chunk-442ef248":"6eee528a","chunk-44463067":"c26f9b30","chunk-46859440":"bcd25ff4","chunk-46935e22":"728076c8","chunk-4959ce7b":"15409dea","chunk-4c4d891b":"163f2d46","chunk-4d256fd4":"e0ce42bf","chunk-4eefe562":"fc6a6f6e","chunk-504cf5c1":"9edbd7da","chunk-513adf48":"035ff526","chunk-557cc83c":"6e827ea0","chunk-56ee7dc8":"dacb0414","chunk-582c3a99":"fbdd41e3","chunk-58f38132":"6115c069","chunk-59e1a30f":"1453d5a4","chunk-5afdcf28":"00ce3b34","chunk-5c1bdabc":"61e32ba6","chunk-5c92b2f1":"b297462a","chunk-5d3d7a3d":"c3d77ec8","chunk-5d4f5752":"7ef169dd","chunk-5fd65b14":"139740bd","chunk-6193f896":"561e5f3b","chunk-62291d98":"60b7f807","chunk-64b21ab9":"6ac0dbf6","chunk-64bc35ac":"ff5886b4","chunk-66dd2376":"3106aae7","chunk-6701c36e":"caab852e","chunk-6a220b08":"ec07b93e","chunk-6dd17c6a":"178300af","chunk-6e035a16":"99f9b23e","chunk-6ea7681e":"43fb5527","chunk-6f97a383":"30b3ea21","chunk-7044e334":"965f41be","chunk-712d078a":"121cf982","chunk-718392ba":"37663718","chunk-743f1192":"12bf7935","chunk-748d5f1a":"a1abb2ba","chunk-7495d086":"d367f889","chunk-74a14eea":"648addcd","chunk-74b16ab6":"73b5c26a","chunk-758f4986":"918e6915","chunk-78532434":"ce99ac2b","chunk-79ed193c":"9da047c3","chunk-7aa62b57":"34fdafa7","chunk-7e2b3b0e":"1cfa3737","chunk-8be36974":"781ab22f","chunk-8c410afa":"52c75205","chunk-8d4623a0":"467476a9","chunk-9630d94e":"f6ce1eca","chunk-977082c8":"6a4e1158","chunk-97bbfa4c":"bd2bbe8b","chunk-97f32d3c":"bb00a641","chunk-9c2f9a36":"d1cc2656","chunk-a3a5e880":"c091aa78","chunk-a4921472":"a2ad0f61","chunk-a8f91d06":"1e16f6bb","chunk-aea6b32e":"0baa42a9","chunk-b0c0a824":"b624f808","chunk-bf02d574":"d4b5d979","chunk-c048fa8c":"1833ee9d","chunk-c0d239f0":"b39bc58b","chunk-c3610276":"022e565a","chunk-c57376ea":"1c1fae26","chunk-c89987a2":"54a91ff8","chunk-caf4fc46":"8cead803","chunk-cee1ab34":"3ace8bb0","chunk-d2af32e6":"76431f7d","chunk-d6440b68":"d7dbd896","chunk-deabb03c":"e7afc7ee","chunk-e1d5c402":"54b4a22e","chunk-e39721ca":"3bcbc54c","chunk-e5277dde":"093d9742","chunk-e5774c80":"615f11b3","chunk-f0406aa4":"88412c65","chunk-f0f2fd82":"6e410d1a","chunk-f27d9d74":"41b7e799","chunk-f57c4bf4":"799608d3","chunk-f6eca0ae":"b5a87733","chunk-fc1753dc":"489efca5","chunk-fccf9804":"d7fd8472"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kingnetsmart.com.tw/Sites/housekeeper-web-mgmt/147349/html/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = self["webpackJsonp_MgmtLibrary"] = self["webpackJsonp_MgmtLibrary"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
